import { render, staticRenderFns } from "./SelectedColumn.vue?vue&type=template&id=2b7283d9&scoped=true&"
import script from "./SelectedColumn.vue?vue&type=script&lang=ts&"
export * from "./SelectedColumn.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedColumn.vue?vue&type=style&index=0&id=2b7283d9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7283d9",
  null
  
)

export default component.exports